import { MittProvider } from '@/contexts/mitt';
import { getUrlBoolean } from '@/helpers/UrlParam';
import '@/plugins/day';
import '@/plugins/i18n';
import { ui } from '@/tunnels';
import { Leva } from 'leva';
import AssetService from '@/services/AssetService';
import { useVisibilityChange } from '@uidotdev/usehooks';
import { Howler } from 'howler';

import { ColorManagement } from 'three';
ColorManagement.enabled = true;

export function App() {
  const { disable } = useContextMenu();
  disable();

  // const documentVisible = useVisibilityChange();
  // const muted = useAppStore((state) => state.muted);
  // useEffect(() => {
  //   if (!muted) {
  //     Howler.mute(false);
  //   }
  // }, [documentVisible]);

  return (
    <div
      id="app"
      className="full h-[100lvh]"
    >
      <Leva hidden={!getUrlBoolean('leva')} />
      <MittProvider>
        <Webgl />

        <div className="ui font-gellix pointer-events-none">
          <GamePage />
          <Landing />
          <PopupPrizes />
          <VerifyAge />
          <TheGuidelines />
          <DesktopWarning />

          {/* <LandscapeWarning /> */}
        </div>
      </MittProvider>
    </div>
  );
}
